/** A module. Its name is module:cast/nodes.
 * @module cast/nodes
 */

import type {
  CastaiAutoscalerV1beta1GetProblematicNodesResponseNode as ProblematicNode,
  CastaiAutoscalerV1beta1GetProblematicNodesResponse as ProblematicNodesResponse,
  ExternalclusterV1Node as _NodeResponse,
} from '@cast/openapi';
import { ExternalclusterV1NodeType as NodeRoles } from '@cast/openapi';

export enum NodeStatus {
  unknown = 'unknown',
  pending = 'pending',
  creating = 'creating',
  ready = 'ready',
  notReady = 'notReady',
  draining = 'draining',
  deleting = 'deleting',
  deleted = 'deleted',
  interrupted = 'interrupted',
  detached = 'detached',
}

export enum ComputedNodeStatus {
  CORDONED = 'cordoned',
  DISRUPTED = 'disrupted',
}

export enum NodeResourceOffering {
  ON_DEMAND = 'on-demand',
  FALLBACK = 'fallback',
  SPOT = 'spot',
}

// NodeResourceOffering covers the backend pricing dimensions. Node surfaces
// (node list, node details, rebalancing plan creation pages) also classify sole-tenant nodes,
// which aren't a pricing dimension — this union adds that value where it's
// needed without forcing it into non-node-related code.
export type NodeResourceOfferingWithSoleTenancy =
  | `${NodeResourceOffering}`
  | 'sole-tenant';

// TODO: remove 'not-ready' + Exclude<NodeStatus, NodeStatus.notReady> -> NodeStatus when GRAV-366 is done
export type NodeStatePhase =
  | Exclude<NodeStatus, NodeStatus.notReady>
  | ComputedNodeStatus
  | 'not-ready';

export type Node = Omit<NodeResponse, 'state'> & {
  state: {
    phase?: NodeStatePhase;
  };
  resourceOffering: NodeResourceOfferingWithSoleTenancy;
  unremovable: boolean;
  castNodeId?: string;
  isFailedToDrain: boolean;
};

export type NodeResponse = Omit<_NodeResponse, 'instancePrice'> & {
  /** @deprecated Use `pricingInfo.totalPrice` instead */
  instancePrice: _NodeResponse['instancePrice'];
};

export type {
  ExternalclusterV1Taint as NodeTaint,
  ExternalclusterV1DrainConfig as NodeDrainConfig,
  ExternalclusterV1NodeConfig as AddNodeConfig,
} from '@cast/openapi';
export type { ProblematicNode, ProblematicNodesResponse };
export { NodeRoles };
